import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import ToolDetail from '../views/ToolDetail.vue';
import AboutPage from '../views/AboutPage.vue'; // 引入 AboutPage 组件

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/tool/:id',
    name: 'ToolDetail',
    component: ToolDetail,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage, // 定义 AboutPage 路由
  },
  // 其他路由...
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
